import styled from 'styled-components'
import { CircularProgress } from 'ui/components'

const WrappedSpinner = styled(CircularProgress)`
  margin-top: 10px;
`

const FormPaddingWrapper = styled.div`
  padding: 30px 36px 18px 36px;
`

export const s = { WrappedSpinner, FormPaddingWrapper }
